<template>
  <div class="upload-box">
    <div class="upload-btn" id="uploadBtnDiv">
          <ejs-button class="e-input" isPrimary='true' @click.native='upButton' >{{$t("Common.upload")}}</ejs-button>
    </div>
    <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='file' name='file' id='file' autoUpload='false' :selected='onFileSelect'
                    :allowedExtensions='extensions'
                    :multiple='false'></ejs-uploader>
    </div>
  </div>
</template>
<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../../plugins/eventBus';
  import bus from '../bus.js';
  export default {
    name: 'addDialog',
    components: {
      ProgressBar
    },
    data() {
      return {
        extensions: '.xlsx',
        showProgressBar: false,
        progressVal: 0,
        progressText: '0%',
        versionShow: false,
        dataSource: [
          {text: this.$t('基础'), value: 0},
          {text: this.$t('业务'), value: 1},
        ],
        deliverType: [
          {text: 'Native', value: 0},
          {text: 'Image', value: 1},
          {text: 'Helm', value: 2},
          {text: 'VM', value: 3}
        ],
        versionSource: [],
        brokenFlag:0,
      }
    },
    methods: {
      upButton() {

        let curAddFlag=0;
          for(var index in  document.getElementsByClassName('e-file-select-wrap')){
             let str = document.getElementsByClassName('e-file-select-wrap')[index].outerHTML;
             if(str.indexOf(this.extensions) !== -1){
              curAddFlag = index;
              break;
            }
             if(typeof(str)=="undefined"){
                  break;
             }           
          }
        document
          .getElementsByClassName('e-file-select-wrap')[curAddFlag]
          .querySelector('button')
          .click();
        return false;
      },
      setCancel(param){
        this.brokenFlag = param;
      },
      async onFileSelect(args) {
        this.tryUtilFileLoaded();
      },
      tryUtilFileLoaded(){
        setTimeout(() => {
          try {
            const uploadPrefix = this.randomId();
            this.bigFileUpload(uploadPrefix);
            bus.$emit('fileName', this.getParam()['file']['name']); 
          } catch (error) {
            this.tryUtilFileLoaded();
          }
        }, 100);
      },
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        let randStr = '';
        for (let i = 0; i <= 8; i++) {
          randStr += _temp[Math.round(Math.random(1) * 26)];
        }
        return randStr;
      },
      getVersionList() {
        // 获取适配包版本号
        const url = '/lte/ems/packageManager/queryService';
        this.axios.get(url).then(res => {
          console.log(res.data);
          const list = res.data.map(item => item.pkgVersion);
          this.versionSource = Array.from(new Set(list));
        });
      },
      getParam() {
        let type = 0;
        const file = this.$refs.file.ej2Instances.filesData[0];
        const param = {
          // version: version,
          file: file['rawFile'],
          fileType:file['type'],
          type: type
        };
        return param;
      },
      async checkExistPackage(){
        const url = '/lte/ems/packageManager/isPackageExist';
        const data = this.getParam();
        const fileName = data['file']['name'];
        const params = {
          fileName: fileName
        };
        let exist = new Boolean();
        await this.axios.get(url, { params }).then(res => {
          exist = res.data;
        });
        return exist;
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      async bigFileUpload(uploadPrefix) {
        // 进度条
        this.brokenFlag = 0;
        const data = this.getParam();
        const srcFile = data['file'];
        // 如果文件为空，则退出
        if(!srcFile){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return null;
        }
        if(data['fileType'] != 'xlsx'){
          // this.eventEmit('warning', this.$t('System.fileTypeError'));
          return;
        }

        document.getElementById("uploadBtnDiv").style.display="none";
        EventBus.$emit("setChildProps", {status:0});
        const tempFiles = [];
        // 每片10M
        const perPiece = 1024 *1024 * 10;
        let originalFilePath = '';
        let start = 0;
        let end = 0;
        let index = 0;
        let totalPieces = 0;
        let filesize = srcFile.size;
        let filename = srcFile.name;
        // 计算文件切片总数
        totalPieces = filesize % perPiece == 0 ? filesize/perPiece : filesize/perPiece + 1;
        // 上传文件
        const url = '/lte/ems/config/mml/configFilePiece';
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          processData: false,
          async: false,
          contentType: false
        };
        let pecent = 0;
        this.showProgressBar = true;
        while((start < filesize) && this.brokenFlag == 0) {
          // 切片上传
          end = start + perPiece;
          if(end > filesize) {
            // 一次性上传
            end = filesize;
          }
          // 分割文件核心部分slice
          const chunk = srcFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk, filename);
          formData.append("totalPieces", totalPieces);
          formData.append("index", index);
          formData.append("process", pecent);
          formData.append("prefix", uploadPrefix);
          await this.$axios.post(url, formData, config).then(response => {
            const result = response['data']['resultVal'];
            tempFiles.push(result['msg']);
            originalFilePath = result['message'];
            // // 进度条
            pecent=(100*(end)/filesize).toFixed(2);
            if(pecent>=100){
              pecent=100.00;
            }
            this.progressVal = pecent;
            this.progressText = pecent + '%';
          });
          start = end;
          index ++;
        }
        if(this.brokenFlag != 0){
          this.clearCancelTempFile(filename);
        }
      },
      clearCancelTempFile(filename){
        const url = '/lte/ems/config/mml/clearCancelConfigFile';
        const param = {
          prefix: filename
        };
        this.$axios.post(url, param).then(res => {
          console.log("clear cancel tempFile...");
        });
     } ,
    destroyed() {
      this.brokenFlag = 1;
    }
    }
  }
</script>